import script from "./CustomPopoverKnow.vue?vue&type=script&setup=true&lang=js"
export * from "./CustomPopoverKnow.vue?vue&type=script&setup=true&lang=js"

import "./CustomPopoverKnow.vue?vue&type=style&index=0&id=662ba2e0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-662ba2e0"]])

export default __exports__